export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/environments/environment.ts